import request from "@/utils/request";
import { apiConfig } from "../config/api";

// 测评账号分页列表
export function getUserPager(req, pager) {
  Object.assign(req, pager);
  return request({
    url: apiConfig.importUserAccount.api.userPager.url.pager,
    method: "post",
    data: req
  });
}

// 查询测评账号分页列表
export function searchUserPager(req, pager) {
  Object.assign(req, pager);
  return request({
    url: apiConfig.importUserAccount.api.userPager.url.searchPager,
    method: "post",
    data: req
  });
}

// 查询考场列表
export function getExamList() {
  return request({
    url: apiConfig.importUserAccount.api.produce.url.getExamList,
    method: "get"
  });
}
// 生成用户账号
export function produceUserAccount(req) {
  return request({
    url: apiConfig.importUserAccount.api.produce.url.produceUserAccount,
    method: "post",
    params: req
  });
}
// 导出用户账号
export function exportUserAccount(req) {
  return request({
    url: apiConfig.importUserAccount.api.produce.url.exportUserAccount,
    method: "get",
    params: req,
    responseType: "blob"
  });
}
// 导出用户账号
export function exportAccountError(req) {
  return request({
    url: apiConfig.importUserAccount.api.produce.url.exportAccountError,
    method: "get",
    params: req,
    responseType: "blob"
  });
}

// 导出用户测评信息
export function downloadUserAccount(searchForm) {
  return request({
    url: apiConfig.userInfo.api.downloadUserAccount.url,
    method: "post",
    data: searchForm,
    responseType: "blob"
  });
}

// 确认导入用户测评信息
export function doUploadExistUser(req) {
  return request({
    url: apiConfig.importUserAccount.api.produce.url.doCreateAccount,
    method: "post",
    params: req
  });
}
